/**
 * Holds case history and unresolved cases.
 *
 * NOTE: Because 2 different tables are used to present the 2 stores (Resolution and History), it would be difficult to combine
 * the stores into 1 as there will eventually be a date and pagination component that would need to be in sync
 * between the 2 tables.
 * For now, when changes are made to an unresolved case report, those changes must be ported to the history view.
 */
import Vue from 'vue'
import axios from 'axios';
const state = {
    caseReports: [],
    totalCaseReports: 0
}

const getters = {
    caseReports: state => state.caseReports,
    totalCaseReports: state => state.totalCaseReports
}

const actions = {
    async fetchCaseReports({ commit }, request) {
        return new Promise((resolve, reject) => {
            axios.post("/api/caseReport", request)
                .then((res) => {
                    commit('setCaseReports', res.data)
                    resolve(res.data.totalCaseReports);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
    async updateCaseReportStatus({ commit }, { caseReportIds, status, comment }) {
        return new Promise((resolve, reject) => {
            axios.post("/api/caseReport/status", {
                caseReportIds: caseReportIds,
                status: status,
                comment: comment,
            })
            .then((resp) => {
                commit('updateCaseReportStatus', { caseReportIds, status, comment: resp.data.comment})
                resolve()
            })
            .catch((error) => {
                reject(error);
            });
        })
    },
    async assignCaseReports({ commit }, { caseReportIds, assignedToUserName, comment }) {

        return new Promise((resolve, reject) => {
            axios
                .post("/api/caseReport/assignee", {
                    caseReportIds: caseReportIds,
                    assignedToUserName: assignedToUserName,
                    comment: comment,
                })
                .then((resp) => {
                    commit('assignCaseReports', { caseReportIds, assignedToUserName, comment: resp.data.comment})
                    resolve()
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    async saveComment({commit}, {caseReportId, commentText}){
        return new Promise((resolve, reject) => {
            axios
                .post("/api/caseReport/"+ caseReportId + "/comment", {comment: commentText})
                .then((resp) => {
                    commit('addComment', { caseReportId, comment: resp.data })
                    resolve()
                })
                .catch((error) => {
                    reject(error);
                });
        })
    },
    async addCaseIdToReport({ commit }, { caseReportId, caseId }) {
        commit('addCaseIdToReport', { caseReportId, caseId })
    },
}

const mutations = {
    clearCaseReports(state){
        state.caseReports = []
    },
    setCaseReports(state, data) {
        state.caseReports = data.caseReports
        state.totalCaseReports = data.totalCaseReports
    },
    // resolveCaseReport: function (state, caseReport) {
    //     // Removes this case report from unresolved.
    //     state.unresolvedCases = state.unresolvedCases.filter(thisCaseReport => thisCaseReport.id !== caseReport.id);
    //     // Update this case in History store with resolution data.
    //     var index = state.searchHistory.findIndex((obj => obj.id == caseReport.id))
    //     Vue.set(state.searchHistory, index, caseReport)
    // },
    /**
     * Adds a new case ID to an unresolved case report when a user saves a case from an unresolved case within resolution
     */
    addCaseIdToReport: function (state, { caseReportId, caseId }) {
        // Update Unresolved caseReport with new case ID
        var index = state.caseReports.findIndex((obj => obj.id == caseReportId))
        if (index >= 0) {
            var caseReport = state.caseReports[index];
            caseReport.searchCase.id = caseId;
            Vue.set(state.caseReports, index, caseReport);
        }

        // Update History caseReport with new case ID
        // index = state.searchHistory.findIndex((obj => obj.id == caseReportId))
        // if (index >= 0) {
        //     caseReport = state.searchHistory[index];
        //     caseReport.searchCase.id = caseId;
        //     Vue.set(state.searchHistory, index, caseReport);
        // }
    },
    updateCaseReportStatus: function (state, { caseReportIds, status , comment }) {
        state.caseReports.forEach((element) => {
            if (caseReportIds.includes(element.id)) {
                element.status = status
                if(comment != null){
                    element.comments.push(comment)
                }
            }
        })
    },
    assignCaseReports: function (state, { caseReportIds, assignedToUserName, comment }) {
        state.caseReports.forEach((element) => {
            if (caseReportIds.includes(element.id)){
                element.assignedToUserName = assignedToUserName
                if(comment != null){
                    element.comments.push(comment)
                }
            }
        })
    },
    addComment: function(state, {caseReportId, comment}){
        state.caseReports.forEach((element) => {
            if (element.id == caseReportId){
                element.comments.push(comment)
            }
        })
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}
